webpackJsonp([173647032489128],{

/***/ 1193:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 958:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = exports.FaqsTemplate = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _PageHeader = __webpack_require__(15);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _Content = __webpack_require__(6);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Accordion = __webpack_require__(76);
	
	var _Accordion2 = _interopRequireDefault(_Accordion);
	
	__webpack_require__(1193);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Export Template for use in CMS preview
	var FaqsTemplate = exports.FaqsTemplate = function FaqsTemplate(_ref) {
	  var title = _ref.title,
	      subtitle = _ref.subtitle,
	      accordionSection = _ref.accordionSection,
	      body = _ref.body,
	      meta = _ref.meta;
	
	
	  return _react2.default.createElement(
	    'main',
	    { className: 'Faqs background-dots' },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      { defaultTitle: meta && meta.title || title + ' | Great Start ELC' },
	      meta && _react2.default.createElement('meta', { name: 'description', content: meta.description }),
	      meta && _react2.default.createElement('link', { rel: 'canonical', href: meta.canonical })
	    ),
	    _react2.default.createElement(_PageHeader2.default, { title: title, subtitle: subtitle }),
	    _react2.default.createElement(
	      'section',
	      { className: 'section' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container content' },
	        accordionSection && accordionSection.map(function (_ref2, index) {
	          var title = _ref2.title,
	              accordion = _ref2.accordion;
	          return _react2.default.createElement(
	            'div',
	            { key: 'accordion-' + index, className: 'accordion-section' },
	            title && _react2.default.createElement(
	              'h4',
	              null,
	              title
	            ),
	            _react2.default.createElement(_Accordion2.default, { items: accordion })
	          );
	        })
	      )
	    )
	  );
	};
	
	var Faqs = function Faqs(_ref3) {
	  var page = _ref3.data.page;
	  return _react2.default.createElement(FaqsTemplate, _extends({}, page, page.frontmatter, { body: page.html }));
	};
	
	exports.default = Faqs;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-faqs-js-179fcbd19c69d450915c.js